<template>
  <div class="block">
    <div v-if="hasHeader" class="block-header" :style="headerStyle">
      <div class="header-info">
        <h4 class="block-header-title is-size-4">
          <slot name="header">Default Header</slot>
        </h4>
        <p class="is-marginless is-size-7">
          <slot name="subheader"></slot>
        </p>
      </div>
      <div v-if="hasActions" class="actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    borderedHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasActions() {
      return !!this.$slots.actions
    },
    hasHeader() {
      return !!this.$slots.header
    },
    headerStyle() {
      if (this.borderedHeader) {
        return {
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "20px"
        }
      }
      return {}
    }
  }
}
</script>

<style scoped>
.block {
  background: white;
  padding: 5px 25px;
}

.block-header {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-header-title {
  padding: 0;
  margin: 0;
  font-weight: 500;
  color: #333;
}
</style>
